export default {
  type: {
    bpm: 'bpm',
    mood: 'Mood',
    instrument: 'Instrument',
    instrument_plural: 'Instruments',
    genre: 'Genre',
    energy: 'Energy',
    era: 'Era',
    key: 'Key',
    key_plural: 'Keys',
    vocal: 'Vocal',
    vocal_plural: 'Vocals',
  },
};
